<template>
  <CardedForm
    style="max-width: 600px; margin: auto !important"
    ref="carded_login_form_ref"
    id="login_form"
    title="Login To Access Your Account"
    :is_loading="is_loading"
    @on-submit-form="on_login"
    :errors="errors"
    :message="message"
    @on-auto-fill="on_auto_fill"
  >
    <TextField
      v-model="email"
      :validation_rules="email_rules"
      label="E-mail Address/ Phone Number"
      icon="mdi-email-variant"
      :disabled="is_loading"
    ></TextField>

    <TextField
      v-model="password"
      :validation_rules="password_rules"
      label="Password"
      icon="mdi-key-variant"
      type="password"
      :disabled="is_loading"
    ></TextField>
    <template v-slot:clearbtnslot>
      <v-btn
        class="ma-0"
        dense
        text
        color="success"
        :disabled="is_loading"
        @click="on_forgot_password"
      >
        Forgot password ?
      </v-btn>
    </template>
    <template v-slot:lower>
      <div class="text-muted mt-5">-- OR --</div>
      <v-divider></v-divider>
      <v-row class="mb-5x">
        <v-col cols="12 mt-0 mb-1 pb-0 pt-2 text-left">
          <v-btn
            class="ma-0 mb-2"
            dense
            text
            color="success"
            :disabled="is_loading"
            @click="on_signup"
          >
            Create an account/ Sign up
          </v-btn>
        </v-col>
      </v-row>
    </template>
  </CardedForm>
</template>

<script>
import CardedForm from "./../components/CardedForm";
import TextField from "./../components/TextField";

import page_info from "./../lib/page_info";
import Utils from "./../lib/Utils";
import ServerClient from "./../lib/ServerClient";
export default {
  name: "LoginComponent",
  components: {
    CardedForm,
    TextField
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
    redirect_on_success: {
      type: Boolean,
      default: false,
    },
    emit_on_links: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    errors: [],
    message: "",
    email: "",
    email_rules: [
      Utils.validate.is_required("Email address or Phone number is required"),
      Utils.validate.email_format_or_phone(
        "Invalid input, must be a valid email address or a valid phone number"
      ),
    ],
    password: "",
    password_rules: [
      Utils.validate.is_required("Password is required"),
      Utils.validate.max_length(
        15,
        "Password should be less than 16 characters long"
      ),
    ]
  }),
  methods: {
    on_auto_fill() {
      this.email = "+256779488038";
      this.password = "qwerty2015";
    },
    on_assign_email_and_phone_number(values) {
      this[values.prop] = values.value;
    },
    on_assign_first_name_and_last_name(values) {
      this[values.prop] = values.value;
    },
    on_login() {
      //form is already validated
      this.errors = [];
      this.message = "";
      this.$emit("on-show-loader");
      ServerClient.Login.login(
        {
          email: this.email,
          password: this.password,
        },
        (res) => {
          // console.log("login ", res);
          this.$refs.carded_login_form_ref.on_clear_form();
          // this.$refs.carded_login_form_ref.show_message_dialog();
          this.$emit("on-hide-loader");
          if(this.prevRoute && this.prevRoute.path == "/activate"){
            //must be coming from a signup
            //so we go back to where we started from
            var path = localStorage.getItem("before_singup_route");
            this.$router.push(path);
            return;
          }

          var user = ServerClient.Login.get_logged_in_user();
          this.$emit('set-user',user);
          this.$emit('login-success');
          if(this.redirect_on_success){
            var is_admin = Utils.is_admin(user);
            if(is_admin){
                this.$router.push("/admin/dashboard");
            }else{
                this.$router.push("/owner/dashboard");
            }
          }
          
        },
        (errors) => {
          // console.log("errors ", errors);
          this.errors = errors;
          this.$refs.carded_login_form_ref.show_error_dialog();
          this.$emit("on-hide-loader");
        }
      );
    },
    on_forgot_password(){
      if(this.emit_on_links == true){
        this.$emit("on-forget-password");
      }else{
        this.$router.push("/forgot_password");
      }
    },
    on_signup(){
      if(this.emit_on_links == true){
        this.$emit("on-signup");
      }else{
        this.$router.push("/signup");
      }
    }
  },
};
</script>